// extracted by mini-css-extract-plugin
export default {"root":"WxIBs47Y2K6577lMiecJ"};